import { useRef, useState } from "react";
import { createMemoryRouter, RouterProvider } from "react-router-dom";

import { preloadAppSetting } from "./booking/api/appSetting/useAppSettingQuery";
import useCsrfToken from "./booking/api/booking/useCsrfToken";
import { AppContext } from "./booking/context/AppContext";
import { ArrivalDateContext } from "./booking/context/ArrivalDateContext";
import { PackageContext } from "./booking/context/PackageContext";
import { createArrivalDateStore } from "./booking/store/arrival/arrivalDateStore";
import { ARRIVAL_DATE_PARAM, PROFILE_PARAM } from "./consts";
import "./main.css";
import router from "./router";

type RouterType = ReturnType<typeof createMemoryRouter>;

preloadAppSetting();

const App = ({
  packageId,
  customRouter,
}: {
  packageId: number;
  customRouter?: RouterType;
}) => {
  const searchParams = new URLSearchParams(document.location.search);
  const dateParam = searchParams.get(ARRIVAL_DATE_PARAM);
  const profile = searchParams.get(PROFILE_PARAM);
  const store = useRef(createArrivalDateStore({ dateParam })).current;
  const packageContext = {
    packageId: +packageId,
  };
  const [appId, setAppId] = useState("");
  const profileParam = profile ? `?profile=${profile}` : "";
  const rootDOM = document.querySelector("#booking-root");
  useCsrfToken(profileParam);

  return (
    <AppContext.Provider value={{ appId, setAppId, profile, rootDOM }}>
      <PackageContext.Provider value={packageContext}>
        <ArrivalDateContext.Provider value={store}>
          <RouterProvider router={customRouter ?? router} />
        </ArrivalDateContext.Provider>
      </PackageContext.Provider>
    </AppContext.Provider>
  );
};

export default App;
